
import React from "react";
import {classNames} from "../../../util/util-helpers";
import Button from "../../button";

export default function ButtonsGroup({name, data, value, disabled, addClass, addButtonClass, textClass, onChange, roundedClass = "rounded-md", isLoading, toolTips}) {
    const buttonData = data;
    const buttonKeys = Object.keys(buttonData);

    return (
        <div
            className={
                classNames(
                    addClass,
                    !disabled ? "hover:bg-tm-gray-200" : "",
                    disabled ? "opacity-60" : "",
                    roundedClass,
                    "group p-0.5 flex bg-tm-gray-300",
                    isLoading ? "relative" : ""
                )
            }
        >
            {
                buttonKeys.map((buttonValue, i) => {
                    const isActive = value === buttonValue;

                    return (
                        <Button
                            key={buttonData[buttonValue] + "-" + i}
                            toolTip={toolTips?.[buttonValue]}
                            disabled={disabled}
                            className={classNames(
                                "grow cursor-pointer justify-center",
                                addButtonClass,
                                isActive
                                    ? "p-1.5 lg:px-3 flex items-center shadow-xs ring-1 ring-black/10 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus:outline-hidden focus-visible:ring-offset-gray-100 focus-visible:ring-opacity-50"
                                    : "p-1.5 lg:px-3 flex items-center text-tm-gray-700 focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus:outline-hidden focus-visible:ring-offset-gray-100",
                                roundedClass,
                                isActive && !disabled ? "bg-inverse text-primary" : "",
                                isActive && disabled ? "bg-tm-gray-100 text-tm-gray-700" : "",
                                textClass ? textClass : "text-sm font-medium capitalize",
                                disabled ? "cursor-default" : "",
                                isLoading ? "invisible" : ""
                            )}
                            onClick={() => disabled ? null : onChange(name, buttonValue)}
                        >
                            {buttonData[buttonValue]}
                        </Button>
                    )
                })
            }
        </div>
    )
}